import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { ref, getDownloadURL } from 'firebase/storage';
import { auth, db, storage } from '@/config/firebase';
import type { AdminUser } from '@/shared/types';

export async function signIn(
    email: string,
    password: string,
): Promise<AdminUser> {
    const credential = await signInWithEmailAndPassword(auth, email, password);
    const userDoc = await getDoc(doc(db, 'WebAdmins', credential.user.uid));
    const userData = userDoc.data();

    if (!userData?.isAdmin) {
        await signOut(auth);
        throw new Error(
            'You do not have permission. Please contact your administrator.',
        );
    }

    const imagePath = userData.userImage
        ? `UserImages/${userData.userImage}`
        : 'UserImages/AA_default.gif';
    const imageUrl = await getDownloadURL(ref(storage, imagePath));

    return {
        uid: credential.user.uid,
        userName: userData.userName ?? '',
        email: userData.email ?? email,
        isAdmin: true,
        userImage: imageUrl,
    };
}

export async function logOut(): Promise<void> {
    await signOut(auth);
}
